import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  getBrand: async ({ commit }) => {
    try {
      const res = await axios.get(`/brands`);
      commit('mutateBrand', res.data);
      return res;
    } catch (error) {
      return error;
    }
  }
};

export const mutations = {
  mutateBrand: (state, payload) => {
    state.brand = payload;
  }
};

export const getters = {
  getMainProjectName(state) {
    return state?.brand?.mainProjectName || '';
  },

  getHasLabelFeature(state) {
    return state?.brand?.hasLabelFeature;
  }
};

function initialState() {
  return {
    brand: { colors: { brand: '' } }
  };
}
